export const paymentEn = {
    gxzfcg:"Congratulations! The order has been paid successfully!",
    fhdd:"Click jump to check service order list",
    djfh:"Return service order"
}


// WEBPACK FOOTER //
// ./src/lang/home/payment/indexEn.js